export default "__VITE_ASSET__DU_cOwK6__"